import { MessageCircle } from "lucide-react";
import { CONTATO } from "../data/chales";

export default function Header() {
  return (
    <header
      className="fixed left-0 right-0 top-0 z-40 border-b border-[#1C3026]/10 bg-[#F6F5F2]/85 backdrop-blur-md"
      data-testid="site-header"
    >
      <div className="flex h-16 items-center justify-between px-6 md:px-12 lg:px-24">
        <a href="#topo" className="flex items-center gap-3" data-testid="header-logo-link">
          <img
            src="/logo.jpg"
            alt="Laguna Alto Viçosa"
            className="h-10 w-10 rounded-full border border-[#1C3026]/20 object-cover"
          />
          <span className="text-xs font-bold uppercase tracking-[0.25em] md:text-sm">
            Laguna Alto Viçosa
          </span>
        </a>
        <nav className="hidden items-center gap-8 text-xs font-bold uppercase tracking-[0.15em] md:flex">
          <a href="#chales" className="transition-colors hover:text-[#8C5A40]" data-testid="nav-chales">
            Chalés
          </a>
          <a href="#experiencia" className="transition-colors hover:text-[#8C5A40]" data-testid="nav-experiencia">
            Experiência
          </a>
          <a href="#contato" className="transition-colors hover:text-[#8C5A40]" data-testid="nav-contato">
            Contato
          </a>
          <a
            href={`https://wa.me/${CONTATO.whatsapp}`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 bg-[#1C3026] px-4 py-2 text-[#F6F5F2] transition-colors hover:bg-[#8C5A40]"
            data-testid="nav-whatsapp-btn"
          >
            <MessageCircle className="h-4 w-4" /> Reservar
          </a>
        </nav>
        <a
          href="#chales"
          className="bg-[#1C3026] px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] text-[#F6F5F2] md:hidden"
          data-testid="nav-reservar-mobile"
        >
          Reservar
        </a>
      </div>
    </header>
  );
}
